import { render } from "./SpecialList.vue?vue&type=template&id=34c95ab2&scoped=true"
import script from "./SpecialList.vue?vue&type=script&lang=js"
export * from "./SpecialList.vue?vue&type=script&lang=js"

import "./SpecialList.vue?vue&type=style&index=0&id=34c95ab2&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c95ab2"]])

export default __exports__